import { formatInTimeZone } from 'date-fns-tz'
import { getTimezoneAbbr } from 'lib/time'
import { Heading, Text } from '@workwhile/ui'

interface Props {
  positionName: string
  startsAt: string
  endsAt: string
  timezone: string
  locationName?: string
}

export const ShiftSummary = ({
  positionName,
  startsAt,
  endsAt,
  timezone,
  locationName,
}: Props) => {
  const startDate = new Date(startsAt)
  const endDate = new Date(endsAt)
  const formattedStartsAt = formatInTimeZone(startDate, timezone, 'h:mma')
  const formattedEndsAt = formatInTimeZone(endDate, timezone, 'h:mma')

  return (
    <>
      <Heading my={0} mb={1} level={4} maxLines={1}>
        {positionName}
      </Heading>
      <Text maxLines={1}>
        {formattedStartsAt} - {formattedEndsAt}{' '}
        {getTimezoneAbbr(timezone, startDate)} -{' '}
        {locationName ?? 'Locationless'}
      </Text>
    </>
  )
}
